import JSONModel from "sap/ui/model/json/JSONModel";
import { Routes } from "akademika/akamont/constants/Routes";
import { GetUserRoleAccess } from "akademika/akamont/services/AuthService";
import { SpecificationListFilters } from "akademika/akamont/models/SpecificationListFilters";
import { GetStateForSpecificationStatus } from "../../utils/SpecificationStatusUtil";
import UI5Date from "sap/ui/core/date/UI5Date";
import { FilterController } from "../sharedControllers/FilterController";
import CustomMultiComboBox from "akademika/akamont/customControls/CustomMultiComboBox";

/**
 * @namespace akademika.akamont.pages.specificationList
 */
export default class SpecificationList extends FilterController {
  route = Routes.SPECIFICATION_LIST;
  parentRoute = Routes.DASHBOARD;

  public override onInit() {
    super.onInit();

    const defaultFilters: SpecificationListFilters = {
      partnerId: undefined,
      date: { from: undefined, to: undefined },
      creatorIds: undefined,
      showDeleted: false,
    };

    this.initFilters(defaultFilters, "api/Specification/GetSpecificationList");
  }

  public async onRouteMatched() {
    this.setModel(new JSONModel(GetUserRoleAccess()), "userRoleAccess");

    await this.fetchModel("api/Specification/GetFilterOptions", "filterOptions").then(() => {
      this.setSignleBusinessUnit();
      this.updateDefaultFilters();
    });

    await this.applyFilters();
  }

  private setSignleBusinessUnit() {
    const model = this.getModel("filterOptions") as JSONModel;
    let businessUnitList = model.getProperty("/businessUnits") as { name: string; businessUnitId: int; }[];

    if (businessUnitList && businessUnitList.length === 1) {
      const businessUnitFitler = this.byId("filterBusinessUnit") as CustomMultiComboBox;
      businessUnitFitler.setSelectedKeys([businessUnitList[0].businessUnitId.toString()]);

      this.setModel(new JSONModel({ isDisabled: true }), "businessUnits");
    } else {
      this.setModel(new JSONModel({ isDisabled: false }), "businessUnits");
    }
  }

  private updateDefaultFilters() {
    const model = this.getModel("filterOptions") as JSONModel;
    const businessUnitList = model.getProperty("/businessUnits") as { name: string; businessUnitId: int; }[];
    if (businessUnitList && businessUnitList.length > 0) {
      this._defaultFilters["businessUnitIds"] = businessUnitList.map(bu => bu.businessUnitId);
    } else {
      this._defaultFilters["businessUnitIds"] = undefined;
    }
    const partnerId = model.getProperty("/partnerId") as number;
    if (partnerId) {
      this._defaultFilters["partnerId"] = partnerId;
    } else {
      this._defaultFilters["partnerId"] = undefined;
    }
  }

  public async onSpecificationDetails(specificationId: number) {
    this.navTo(Routes.SPECIFICATION_DETAILS, { id: specificationId });
  }

  public async onNewSpecification() {
    this.navTo(Routes.SPECIFICATION_ADD);
  }

  public getStateForSpecificationStatus = GetStateForSpecificationStatus;

  public formatDateRange(
    from: string | Date | UI5Date,
    to: string | Date | UI5Date
  ) {
    return `${from || ""} - ${to || ""}`;
  }
}
